/* eslint-disable no-console */
import React, {
    useEffect,
    useMemo,
    useRef,
    forwardRef,
    useImperativeHandle,
} from 'react';
import { PopupFilter } from '@fairygodboss/ui';

export const CompanySizeFilter = forwardRef(
    (
        {
            isSM,
            companySizeOpen,
            isCompanySizeOpen,
            onCompanySizeSelect,
            bodyRef,
            companySizes,
            activeCompanySizes,
        },
        ref
    ) => {
        const mountedFilters = useRef(activeCompanySizes);

        useImperativeHandle(ref, () => ({
            setFilter: () => onCompanySizeSelect(mountedFilters.current),
        }));

        useEffect(() => {
            mountedFilters.current = activeCompanySizes;
        }, [activeCompanySizes]);

        return useMemo(() => {
            const css = {
                span: {
                    minWidth: '25px',
                },
            };
            if (!isSM) {
                css.paddingRight = '10px';
                css.marginLeft = '0px';
                css.marginRight = '0px';
            }
            return (
                <PopupFilter
                    data-qa="Jobs-Search-CompanySize-Filter"
                    open={companySizeOpen}
                    mr="24px"
                    label="Company Size"
                    labelName="Company Size"
                    isMulti
                    options={companySizes?.map((c) => ({
                        label: c.displayName,
                        value: c.value,
                        count: c.count,
                    }))}
                    onFilterPress={() => {
                        onCompanySizeSelect(mountedFilters.current);
                        isCompanySizeOpen(!companySizeOpen);
                    }}
                    onPress={() => null}
                    selectionChange={(val) => {
                        if (!val.length && !companySizeOpen) {
                            onCompanySizeSelect(val);
                        }
                        mountedFilters.current = val;
                    }}
                    selector={bodyRef}
                    searchable={false}
                    selection={activeCompanySizes}
                    css={css}
                />
            );
        }, [
            companySizes,
            activeCompanySizes,
            isSM,
            companySizeOpen,
            bodyRef,
            isCompanySizeOpen,
            onCompanySizeSelect,
        ]);
    }
);
